import type { Message, MessageHandler } from '~/Features/Messaging/types';

export class MessageBroker {
    private static MessageHandlersByMessageId: { [id: string]: MessageHandler[] } = {};

    public static subscribe(handler: MessageHandler, messageId: string): void {
        const handlers = this.MessageHandlersByMessageId[messageId];

        if (handlers) {
            handlers.push(handler);
        } else {
            this.MessageHandlersByMessageId[messageId] = [handler];
        }
    }

    public static unsubscribe(handler: MessageHandler, messageId: string): void {
        const handlers = this.MessageHandlersByMessageId[messageId];

        if (handlers) {
            this.MessageHandlersByMessageId[messageId] = handlers.filter(h => h !== handler);
        }
    }

    public static publish(message: Message): void {
        const handlers = this.GetMessageHandlers(message.id);

        handlers.forEach(handler => handler.handle(message));
    }

    public static schedulePublish(message: Message, delay: number): void {
        setTimeout(() => MessageBroker.publish(message), delay);
    }

    private static GetMessageHandlers(messageId: string): MessageHandler[] {
        return this.MessageHandlersByMessageId[messageId] || [];
    }
}
